import React from 'react';
import './About.scss'; // 直接引入 SCSS 文件

const About = () => {
    return (
        <div>
            <div className="about-container">
                <h2 className="about-heading">About Page</h2>
                <div className="title">title</div>
            </div>
            <div className="title">title</div>
        </div>
    );
};


export default About;
